export const BOTTOM_TEXT = "Can't find your bank?";
export const LINK_TEXT = 'Search';
